import {Leaderboard} from 'shells/leaderboard/leaderboard';

import type {GetChatbotReport_chatbotReport_aiMetrics_commonTopics as Topic} from 'nutshell-graphql-types';

import {LEADERBOARD_EMPTY_STATE_PROPS} from './consts';
import {THREAD_SIDEBAR_OPEN_SOURCES} from './consts';
import {mapTopicsToLeaderboardRows} from './helpers';
import {useOpenThreadListSidebar} from './use-open-thread-list-sidebar';

import styles from './chatbot-report-content.module.css';

interface Props {
    commonTopics: Topic[];
    frustrationTopics: Topic[];
}

export function LeaderboardsSection(props: Props) {
    const openThreadListSidebar = useOpenThreadListSidebar();

    const handleOpenTopic = (topic: Topic) => {
        openThreadListSidebar({
            threadIds: topic.threadIds,
            title: topic.topic,
            subtitle: 'See recent conversations where this topic was discussed',
            source: THREAD_SIDEBAR_OPEN_SOURCES.TOPICS_SECTION,
        });
    };

    const commonTopicRows = mapTopicsToLeaderboardRows(props.commonTopics, handleOpenTopic);
    const frustrationTopicRows = mapTopicsToLeaderboardRows(
        props.frustrationTopics,
        handleOpenTopic
    );

    return (
        <div className={styles.container}>
            <div className='full-width'>
                <Leaderboard
                    title='Most common topics'
                    subtitle='Top 5 topics by conversation volume in the selected time period'
                    rowsData={commonTopicRows}
                    hideMedal={true}
                    emptyStateProps={LEADERBOARD_EMPTY_STATE_PROPS}
                    hasConsecutivePositions={true}
                />
            </div>
            <div className='full-width'>
                <Leaderboard
                    title='Top frustration topics'
                    subtitle='Top 5 topics where users expressed frustration and requested human help'
                    rowsData={frustrationTopicRows}
                    hideMedal={true}
                    emptyStateProps={LEADERBOARD_EMPTY_STATE_PROPS}
                    hasConsecutivePositions={true}
                />
            </div>
        </div>
    );
}
